import axios from "axios"

//aqui
//Alterar para em projeto/producao e/ou Homolocao
// versao.js basutlaxios.js baseultapi.js api.js e ambiente.js

//Maquina
//const BASE_URL = "https://localhost:44308/api"

//Homologacao
//const BASE_URL = "http://pa.flag.com.br:81/api"

//Producao
const BASE_URL = "https://back.heitools.com.br/api"


function logoutUser() {
    localStorage.removeItem("access_token")
    localStorage.removeItem("refresh_token")
    // localStorage.removeItem("DataINIRel")
    // localStorage.removeItem("DataFIMRel")

    window.location.href = "/"
}

const api = axios.create({
    baseURL: BASE_URL
})

api.interceptors.request.use(
    config => {
        const token = localStorage.getItem("access_token")
        if (token) {
            config.headers['Authorization'] = 'bearer ' + token
        }

        return config
    }
)

api.interceptors.response.use(
    response => {
        return response
    },
    error => {
        // Verificar se código de erro é 401, e se for, realizar requisição de refresh-token
        // Se requisição refresh-token for realizada com sucesso, armazena as novas tokens no 
        // localStorage e refaz a requisição original que falhou

        if (error.response.status === 401) {
            const refreshToken = localStorage.getItem("refresh_token")
            if (refreshToken) {
                //REFRESH-TOKEN
                axios.post(`${BASE_URL}/usuario/refresh-token`, {
                    refreshToken: refreshToken
                })
                    .then(response => {
                        if (response.data) {
                            localStorage.setItem(response.data.token)
                            localStorage.setItem(response.data.refreshToken)
                        }
                        else {
                            logoutUser()
                        }
                    })
                    .catch(error => {
                        logoutUser()
                    })
            }
            else {
                logoutUser()
            }
        }
        else {
            return Promise.reject(error)
        }
    }

)

export default api